/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/qstr.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Performs a query string query. Returns true if the provided query string matches the row.',
  examples: [
    'FROM books\n| WHERE QSTR("author: Faulkner")',
    'FROM books\n| WHERE QSTR("title: Hobbjt~", {"fuzziness": 2})',
  ],
  params: {
    query: 'Query string in Lucene query string format.',
    options: '(Optional) Additional options for Query String as <<esql-function-named-params,function named parameters>>. See <<query-dsl-query-string-query,query string query>> for more information.',
  },
};

export default docs;
